import styled, { css } from 'styled-components'

import { MEDIA_QUERY } from '../../../../styles'
import { Button } from '../../button'


export const CalendarButton = styled(Button)<{ $isActive: boolean }>`
  min-width: 45px;
  width: 45px;
  height: 45px;
  padding: 0 10px;
  @media ${MEDIA_QUERY.MOBILE} {
    padding: 0;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed !important;
    `}
  ${({ $isActive, disabled, theme }) =>
    $isActive &&
    !disabled &&
    css`
      color: ${theme.colors.font.white};
      background: ${theme.colors.common.regular.brightBlue};
      border-color: ${theme.colors.common.regular.brightBlue};

      &:hover {
        box-shadow: none;
        color: ${theme.colors.font.white};
        background: ${theme.colors.common.regular.brightBlue};
      }
    `}
`
